export const PICKER_DATA_HOOKS = {
  Next: 'next-button',
  Prev: 'prev-button',
};

export const PICKER_DATA_PROPS = {
  NextDisabled: 'data-disabled-next',
  PrevDisabled: 'data-disabled-prev',
};
